import store from "../app/store";
import { createAction } from "@reduxjs/toolkit";
import { ACTION_DEVICES_CHANGED as ACTION_DEVICES_CHANGED_DEVICES_PAGE } from "./DevicesPageReducer";
import { ACTION_DEVICES_LOADED as ACTION_DEVICES_LOADED_ALERT_PAGE } from "../alert/AlertNotificationPageReducer";
import { ACTION_DEVICES_CHANGED_GET_ALL_DEVICES } from "./DevicesPageReducer";
import { ACTION_DEVICES_CHANGED as ACTION_DEVICES_CHANGED_VALIDATE_PAGE } from "../rules/validate/ValidatePageReducer";
import { ACTION_DEVICES_CHANGED as ACTION_DEVICES_CHANGED_ANALYSIS_PAGE } from "../rules/analysis/AnalysisPageReducer";
import {
    ACTION_DEVICE_TYPE_CHANGED as ACTION_DEVICE_TYPE_CHANGED_ADD_DEVICE_MODAL,
    ACTION_TAGS_LOADED, ACTION_EVENTS_CHANGED
} from "./add-device-modal/AddDeviceModalReducer";
import {
    ACTION_DEVICE_TYPES_CHANGED as ACTION_DEVICE_TYPES_CHANGED_MSB_PAGE,
} from "../rules/msb/MsbPageReducer";
import { ACTION_DEVICE_TYPES_CHANGED as ACTION_DEVICE_TYPES_CHANGED_VALIDATE_PAGE } from "../rules/validate/ValidatePageReducer"
import { ACTION_DEVICE_TYPES_CHANGED as ACTION_DEVICE_TYPES_CHANGED_ANALYSIS_PAGE } from "../rules/analysis/AnalysisPageReducer"
import { ACTION_DEVICE_TYPES_CHANGED as ACTION_DEVICE_TYPES_CHANGED_RECENT_VIOLATIONS_PAGE } from "../recentviolations/RecentViolationsPageReducer"
import { ACTION_DEVICE_LOADED as ACTION_DEVICE_LOADED_DEVICE_DETAILS_PAGE } from "./details/DeviceDetailsPageReducer";
import { ACTION_DEVICE_LOADED as ACTION_DEVICE_LOADED_CHANGE_DETAILS_PAGE } from "./change-details/ChangeDetailsPageReducer";
import { securedFetch, secureField, secureFields, getDialogId } from "../auth/authService";
import { getSortAndFilterQueryString } from "../view/urlService";
import { DEVICE_API, DEVICE_TYPE_API, DEVICE_BASELINE_API, EVENT_API, TAG_API, VALIDATE_API, DeviceStatus } from "../vars";
import { ConnectionTypes } from "./add-device-modal/ConnectionTypeSection";

import fileSaver from 'file-saver';
import {getAuthHeader} from "../auth/authService";

const uniqueBy = (items, getKey) => {
    const seen = new Set();
    return (items || []).filter(item => {
        const key = getKey(item);
        if (!key || seen.has(key)) {
            return false;
        }

        seen.add(key);
        return true;
    });
};

const uniqueById = (items) => uniqueBy(items, item => item?.id || item?.pk);

export function getAssignedDeviceTypes(deviceList) {
    return uniqueById(
        (deviceList || [])
            .map(device => device?.deviceType)
            .filter(Boolean)
            .map(deviceType => ({
                ...deviceType,
                id: deviceType.id || deviceType.pk
            }))
    );
}

export function getAssignedMsbs(deviceList) {
    return uniqueBy(
        (deviceList || [])
            .filter(device => device?.msb)
            .map(device => {
                const deviceType = device.msb.deviceType || device.deviceType;
                return {
                    ...device.msb,
                    id: device.msb.id || device.msb.pk,
                    deviceType: deviceType ? {
                        ...deviceType,
                        id: deviceType.id || deviceType.pk
                    } : deviceType
                };
            }),
        msb => `${msb?.id}:${msb?.deviceType?.id || msb?.deviceType?.pk || 'all'}`
    );
}

export function getAssignedTags(deviceList) {
    return uniqueById(
        (deviceList || [])
            .flatMap(device => device?.tags || [])
            .filter(Boolean)
            .map(tag => ({
                ...tag,
                id: tag.id || tag.pk
            }))
    );
}

export async function loadAssignedDeviceTargetTypes() {
    const deviceList = await list();
    const deviceTypes = getAssignedDeviceTypes(deviceList);
    const msbList = getAssignedMsbs(deviceList);
    const tags = getAssignedTags(deviceList);

    store.dispatch(createAction(ACTION_DEVICE_TYPE_CHANGED_ADD_DEVICE_MODAL)({ deviceTypes }));
    store.dispatch(createAction(ACTION_DEVICE_TYPES_CHANGED_MSB_PAGE)({ deviceTypes }));
    store.dispatch(createAction(ACTION_DEVICE_TYPES_CHANGED_VALIDATE_PAGE)({ deviceTypes }));
    store.dispatch(createAction(ACTION_DEVICE_TYPES_CHANGED_ANALYSIS_PAGE)({ deviceTypes }));
    store.dispatch(createAction(ACTION_DEVICE_TYPES_CHANGED_RECENT_VIOLATIONS_PAGE)({ deviceTypes }));

    return { deviceList, deviceTypes, msbList, tags };
}

export function list() {
    return securedFetch(DEVICE_API)
        .then(response => {
            if (!response || !response.ok) {
                console.error("Failed to load devices", response);
                return [];
            }
            return response.json();
        })
        .then(data => {
            const devices = Array.isArray(data) ? data : [];
            store.dispatch(createAction(ACTION_DEVICES_CHANGED_GET_ALL_DEVICES)({ allDevices: devices }));
            return devices;
        });

}

export function getAllDevices() {
    return securedFetch(DEVICE_API)
        .then(response => response.json())
        .then(data => {
            return data;
        });

}

export function loadById(id) {
    return securedFetch(`${DEVICE_API}/${id}`)
        .then(response => response.json())
        .then(device => {
            store.dispatch(createAction(ACTION_DEVICE_LOADED_DEVICE_DETAILS_PAGE)({ device: device }))
            store.dispatch(createAction(ACTION_DEVICE_LOADED_CHANGE_DETAILS_PAGE)({ device: device }))
            return device;
        });
}

export function loadDeviceById(id) {
    return securedFetch(`${DEVICE_API}/${id}`)
        .then(response => response.json())
        .then(device => {
            return device;
        });
}

export function listPageable(pageNumber, pageSize) {

    const queryString = getSortAndFilterQueryString(pageNumber, pageSize);

    return securedFetch(`${DEVICE_API}/page?${queryString}`)
        .then(response => response.json())
        .then(data => {
            store.dispatch(createAction(ACTION_DEVICES_CHANGED_DEVICES_PAGE)({ devices: data.page }));
            store.dispatch(createAction(ACTION_DEVICES_LOADED_ALERT_PAGE)({ devices: data.page }));
            // alert ("devices: "+data.page)
            return { devices: data.page, totalPages: data.total, pageNumber, totalRecords: data.records }
        });
}

export function tagList() {
    return securedFetch(TAG_API)
        .then(response => response.json())
        .then((data) => {
            store.dispatch(createAction(ACTION_TAGS_LOADED)({ tags: data }));
            return data;
        });
}

export function eventsList() {
    return securedFetch(EVENT_API)
        .then(response => response.json())
        .then((data) => {
            store.dispatch(createAction(ACTION_EVENTS_CHANGED)({ events: data }));
            return data;
        });
}

export async function loadDeviceTypes() {
    return securedFetch(DEVICE_TYPE_API)
        .then(response => response.json())
        .then(data => {
            store.dispatch(createAction(ACTION_DEVICE_TYPE_CHANGED_ADD_DEVICE_MODAL)({ deviceTypes: data }));
            store.dispatch(createAction(ACTION_DEVICE_TYPES_CHANGED_MSB_PAGE)({ deviceTypes: data }));
            store.dispatch(createAction(ACTION_DEVICE_TYPES_CHANGED_VALIDATE_PAGE)({ deviceTypes: data }));
            return data;
        });
}

export async function loadIntegratedDeviceTypes() {
    return securedFetch(`${DEVICE_TYPE_API}/integrated`)
        .then(response => response.json())
        .then(data => {
            store.dispatch(createAction(ACTION_DEVICE_TYPE_CHANGED_ADD_DEVICE_MODAL)({ deviceTypes: data }));
            store.dispatch(createAction(ACTION_DEVICE_TYPES_CHANGED_MSB_PAGE)({ deviceTypes: data }));
            store.dispatch(createAction(ACTION_DEVICE_TYPES_CHANGED_VALIDATE_PAGE)({ deviceTypes: data }));
            return data;
        });
}

export function loadByDeviceTypeId(id) {
    return securedFetch(`${DEVICE_API}/type/${id}`)
        .then(response => response.json())
        .then(data => {
            store.dispatch(createAction(ACTION_DEVICES_CHANGED_VALIDATE_PAGE)({ devices: data }));
            store.dispatch(createAction(ACTION_DEVICES_CHANGED_ANALYSIS_PAGE)({ devices: data }));
            return data;
        });
}

export async function remove(removeIds) {
    for (const id of removeIds) {
        await securedFetch(`${DEVICE_API}/${id}`, null, 'DELETE');
    }
}

export function patch(device) {
    return securedFetch(DEVICE_API, device, 'PATCH')
        .then((response => response.json()))
}

export function save_orig(device) {
    const deviceData = extractDeviceData(device);

    switch (device.connectionType) {
        case ConnectionTypes.API:
            return saveDeviceApiConnection(deviceData, 'POST');
        case ConnectionTypes.SSH:
            return saveDeviceSshConnection(deviceData, 'POST');
        case ConnectionTypes.WINRM:
            return saveDeviceWinRmConnection(deviceData, 'POST');
        case ConnectionTypes.PowerCLI:
            return saveDevicePowerCLIConnection(deviceData, 'POST');
        default: {
            return securedFetch(DEVICE_API, deviceData, 'POST')
                .then((response => response.json()))
        }
    }
}

export function save(device) {
    let ipString = device.mngtIpAddress;
    if (device.connectionType === ConnectionTypes.M365){
        device.mngtIpAddress = device.msClientId.slice(0, 8);
    }
    else {
        if (!ipString || typeof ipString !== 'string') return [];
        ipString = ipString.trim();
    }
    
    let ipList = parseIpString(device.mngtIpAddress);  
    // If the string contains commas, split and process each part
    let i = 0;
    let result;
    if (ipList.length > 1) {        
        ipList.forEach(ip => {
            i++;
            const deviceData = extractDeviceDataWithIp(device, ip, i);
            switch (device.connectionType) {
                case ConnectionTypes.API:
                    result = saveDeviceApiConnection(deviceData, 'POST');
                    break;
                case ConnectionTypes.SSH:
                    result = saveDeviceSshConnection(deviceData, 'POST');
                    break;
                case ConnectionTypes.WINRM:
                    result = saveDeviceWinRmConnection(deviceData, 'POST');
                    break;
                case ConnectionTypes.PowerCLI:
                    result = saveDevicePowerCLIConnection(deviceData, 'POST');
                    break;
                default: {
                    result = securedFetch(DEVICE_API, deviceData, 'POST')
                        .then((response => response.json()));
                    break;
                }
            }
        }); 
    }
    else {
        const deviceData = extractDeviceData(device);        
        switch (device.connectionType) {
            case ConnectionTypes.API:
                result = saveDeviceApiConnection(deviceData, 'POST');
                break;
            case ConnectionTypes.SSH:
                result = saveDeviceSshConnection(deviceData, 'POST');
                break;
            case ConnectionTypes.WINRM:
                result = saveDeviceWinRmConnection(deviceData, 'POST');
                break;
            case ConnectionTypes.PowerCLI:
                result = saveDevicePowerCLIConnection(deviceData, 'POST');
                break;
            case ConnectionTypes.M365:
                result = saveDeviceMSConnection(deviceData, 'POST');
                break;
            default: {
                result = securedFetch(DEVICE_API, deviceData, 'POST')
                    .then((response => response.json()));
                break;
            }
        }
    }

    return result;
}

function parseIpString(ipString) {
    if (!ipString || typeof ipString !== 'string') return [];
  
    // Remove spaces
    ipString = ipString.trim();
  
    // If the string contains commas, split and process each part
    if (ipString.includes(',')) {
      return ipString
        .split(',')
        .map(s => s.trim())
        .flatMap(part => parseIpString(part)); // recursively handle mixed formats
    }
  
    // If the string contains a dash (range)
    if (ipString.includes('-')) {
      const [startIp, endPart] = ipString.split('-').map(s => s.trim());
      const startOctets = startIp.split('.').map(Number);
  
      // If the dash range includes full IP (e.g. 192.168.0.11-192.168.0.14)
      // Extract only the last octet from the end IP if necessary
      const endOctet = endPart.includes('.')
        ? Number(endPart.split('.').pop())
        : Number(endPart);
  
      const startOctet = startOctets[3];
      const base = startOctets.slice(0, 3).join('.');
  
      const ips = [];
      for (let i = startOctet; i <= endOctet; i++) {
        ips.push(`${base}.${i}`);
      }
      return ips;
    }
  
    // Otherwise, it's a single IP
    return [ipString];
}

const extractDeviceDataWithIp = (data, ip, i) => {

    return {
        id: data.id,
        hostName: data.hostName + i,
        msbId: data.msbId || data.msb?.id,
        msbName: data.msbName,
        mngtIpAddress: ip,
        port: data.port,
        status: data.status || DeviceStatus.UNKNOWN,
        groupId: data?.group?.id || null,
        domainId: data?.domain?.id || null,
        centralCredentialId: data?.centralCredential?.id || null,
        disabled: true,
        criticality: data.criticality,
        tags: data.selectedTags || data.tags || [],
        events: data.selectedEvents || data.events || [],
        deviceTypeId: data.deviceTypeId || data.deviceType?.id,
        connectionType: data.connectionType,
        ownerUsername: data.ownerUsername,

        enableSyslogProcessing: data.enableSyslogProcessing,
        enableSyslogNotification: data.enableSyslogNotification,
        enableEmailNotification: data.enableEmailNotification,
        enableAlerting: data.enableAlerting,
        enableSnmpNotification: data.enableSnmpNotification,

        apiUrl: data.apiUrl,
        apiMonitorUri: data.apiMonitorUri,
        apiPassword: data.apiPassword,
        apiUsername: data.apiUsername,
        apiKey: data.apiKey,

        sshPasswordlessKey: data.sshPasswordlessKey,
        sshUsername: data.sshUsername,
        sshPassword: data.sshPassword,
        passwordChanged: data.passwordChanged,
        //Added by Octopus DevTeam Feb 24 2022
        hasEnabledPassword: data.hasEnabledPassword,
        enablePassword: data.enablePassword,
        winrmUsername: data.winrmUsername,
        winrmPassword: data.winrmPassword,
        powerCliUsername: data.powerCliUsername,
        powerCliPassword: data.powerCliPassword,

        //DevTeam Sept 01, 2022
        healthMonitorInterval: data.healthMonitorInterval,

        sshAlgorithm: data.sshAlgorithm,
        enableRemediation: data.enableRemediation,

        //FIXME unclear
        clientIpAddress: '123.345.456.11',
        msbViolation: 1,
        pciCompliance: 0,
        cisCompliance: 0,
        configurationPath: "test",
    }
}

export function put(device, passwordChanged) {

    const deviceData = extractDeviceData(device);
    const endpoint = `${DEVICE_API}/${device.id}`;

    if (passwordChanged) {
        switch (device.connectionType) {
            case ConnectionTypes.API:
                return saveDeviceApiConnection(deviceData, 'POST', endpoint);
            case ConnectionTypes.SSH:
                return saveDeviceSshConnection(deviceData, 'POST', endpoint);
            case ConnectionTypes.WINRM:
                return saveDeviceWinRmConnection(deviceData, 'POST', endpoint);
            case ConnectionTypes.PowerCLI:
                return saveDevicePowerCLIConnection(deviceData, 'POST', endpoint);
            default: {
                return securedFetch(endpoint, deviceData, 'POST');
            }
        }
    } else {
        return securedFetch(endpoint, deviceData, 'POST');
    }
}

/**
 * API connection type contains two fieldsets, one of them empty.
 */
async function saveDeviceApiConnection(device, method, endpoint = DEVICE_API) {

    if (device.apiUrl && device.apiKey) {
        return secureField('apiKey', device).then(deviceWithSecuredField =>
            securedFetch(endpoint, deviceWithSecuredField, method)
        )
    }

    if (device.apiUsername && device.apiPassword) {
        return secureField('apiPassword', device).then(deviceWithSecuredField =>
            securedFetch(endpoint, deviceWithSecuredField, method)
        )
    }

}

function saveDeviceWinRmConnection(device, method, endpoint = DEVICE_API) {
    return secureField('winrmPassword', device).then(deviceWithSecuredField =>
        securedFetch(endpoint, deviceWithSecuredField, method))
}

/**
 * SSH connection type contains two fieldsets, one of them empty.
 */
function saveDeviceSshConnection(device, method, endpoint = DEVICE_API) {

    if (device.sshPasswordlessKey) {
        return secureField('sshPasswordlessKey', device).then(deviceWithSecuredField =>
            securedFetch(DEVICE_API, deviceWithSecuredField, method)
        )
    }

    if (device.sshUsername && device.sshPassword) {
        //Added by Octopus DevTeam Feb 24 2022
        if (device.hasEnabledPassword) {
            let passwords = ['enablePassword', 'sshPassword'];

            return secureFields(passwords, device).then(deviceWithSecuredField =>
                securedFetch(endpoint, deviceWithSecuredField, method)
            );
        }
        else {
            return secureField('sshPassword', device).then(deviceWithSecuredField =>
                securedFetch(endpoint, deviceWithSecuredField, method)
            )
        }
    }

    if (device.centralCredentialId > 0) {
        return securedFetch(endpoint, device, method)
    }
}

//Added by OCtopus DevTeam Sep 8-2022
function saveDevicePowerCLIConnection(device, method, endpoint = DEVICE_API) {

    if (device.powerCliUsername && device.powerCliPassword) {
        //Added by Octopus DevTeam Feb 24 2022
        /* if(device.hasEnabledPassword){
            let passwords=['enablePassword','powerCliPassword'];
           
            return secureFields(passwords, device).then(deviceWithSecuredField =>
                securedFetch(DEVICE_API, deviceWithSecuredField, method)
            );
        } */
        //else{

        return secureField('powerCliPassword', device).then(deviceWithSecuredField =>
            securedFetch(endpoint, deviceWithSecuredField, method)
        )
        // }
    }
}

function saveDeviceMSConnection(device, method, endpoint = DEVICE_API) {
    return secureField('msClientId', device).then(deviceWithSecuredField =>
        securedFetch(endpoint, deviceWithSecuredField, method))
}

export async function checkConnectivity(device) {

    const deviceData = extractDeviceData(device);

    if (device.id) {
        deviceData.deviceId = device.id;
    }

    switch (deviceData.connectionType) {
        case ConnectionTypes.SSH: {
            return checkConnectivitySshConnection(deviceData);
        }

        case ConnectionTypes.WINRM: {
            return checkConnectivityWinRmConnection(deviceData);
        }

        //Added by Octopus DevTeam Sep 2,2022
        case ConnectionTypes.PowerCLI: {
            return checkConnectivityPowerCLIConnection(deviceData);
        }

        //DevTeam: Jun 15, 2023
        case ConnectionTypes.API: {
            return checkConnectivityAPIConnection(deviceData);
        }

        //DevTeam: Jun 15, 2023
        case ConnectionTypes.M365: {
            return checkConnectivityMSConnection(deviceData);
        }

        default:
            break;
    }

    return Promise.reject('Not supported connection type');
}

async function checkConnectivityWinRmConnection(device) {

    return secureField('winrmPassword', device)
        .then(deviceWithSecuredField => {
            return securedFetch(
                `${VALIDATE_API}/connectivity`,
                deviceWithSecuredField,
                'POST'
            ).then(response => response.json())
        });
}

async function checkConnectivitySshConnection(device) {

    if (device.sshPasswordlessKey) {
        return secureField('sshPasswordlessKey', device).then(deviceWithSecuredField =>
            securedFetch(`${VALIDATE_API}/connectivity`, deviceWithSecuredField, 'POST')
                .then(response => response.json())
        )
    }

    if (device.centralCredentialId) {
        //getDialogId
        return getDialogId('sshPassword', device).then(deviceWithSecuredField =>
            securedFetch(`${VALIDATE_API}/connectivity`, deviceWithSecuredField, 'POST')
                .then(response => response.json())
        );
    }
    if (device.sshUsername && device.sshPassword) {

        if (device.hasEnabledPassword) {
            let passwords = ['enablePassword', 'sshPassword'];
            return secureFields(passwords, device).then(deviceWithSecuredField =>
                securedFetch(`${VALIDATE_API}/connectivity`, deviceWithSecuredField, 'POST')
                    .then(response => response.json())
            );
        }
        return secureField('sshPassword', device).then(deviceWithSecuredField =>
            securedFetch(`${VALIDATE_API}/connectivity`, deviceWithSecuredField, 'POST')
                .then(response => response.json())
        );


    }

}

//Added by Octopus DevTeam Sep 2,2022
async function checkConnectivityPowerCLIConnection(device) {

    if (device.centralCredentialId > 0 || (device.powerCliUsername && device.powerCliPassword)) {
        return secureField('powerCliPassword', device).then(deviceWithSecuredField =>
            securedFetch(`${VALIDATE_API}/connectivity`, deviceWithSecuredField, 'POST')
                .then(response => response.json())
        );
    }
}

//DevTeam: Jun 15, 2023
async function checkConnectivityAPIConnection(device) {

    if (device.apiUrl && device.apiKey) {
        return secureField('apiKey', device)
            .then(deviceWithSecuredField => {
                return securedFetch(`${VALIDATE_API}/connectivity`, deviceWithSecuredField, 'POST')
                    .then(response => response.json())
            });
    }

    if (device.apiUsername && device.apiPassword) {
        return secureField('apiPassword', device)
            .then(deviceWithSecuredField => {
                return securedFetch(`${VALIDATE_API}/connectivity`, deviceWithSecuredField, 'POST')
                    .then(response => response.json())
            });
    }
}

async function checkConnectivityMSConnection(device) {

    return secureField('msClientId', device)
        .then(deviceWithSecuredField => {
            return securedFetch(
                `${VALIDATE_API}/connectivity`,
                deviceWithSecuredField,
                'POST'
            ).then(response => response.json())
        });
}

const extractDeviceData = (data) => {

    return {
        id: data.id,
        hostName: data.hostName,
        msbId: data.msbId || data.msb?.id,
        msbName: data.msbName,
        mngtIpAddress: data.mngtIpAddress,
        port: data.port,
        status: data.status || DeviceStatus.UNKNOWN,
        groupId: data?.group?.id || null,
        domainId: data?.domain?.id || null,
        centralCredentialId: data?.centralCredential?.id || null,
        disabled: true,
        criticality: data.criticality,
        tags: data.selectedTags || data.tags || [],
        events: data.selectedEvents || data.events || [],
        deviceTypeId: data.deviceTypeId || data.deviceType?.id,
        connectionType: data.connectionType,
        ownerUsername: data.ownerUsername,

        enableSyslogProcessing: data.enableSyslogProcessing,
        enableSyslogNotification: data.enableSyslogNotification,
        enableEmailNotification: data.enableEmailNotification,
        enableAlerting: data.enableAlerting,
        enableSnmpNotification: data.enableSnmpNotification,

        apiUrl: data.apiUrl,
        apiMonitorUri: data.apiMonitorUri,
        apiPassword: data.apiPassword,
        apiUsername: data.apiUsername,
        apiKey: data.apiKey,

        sshPasswordlessKey: data.sshPasswordlessKey,
        sshUsername: data.sshUsername,
        sshPassword: data.sshPassword,
        passwordChanged: data.passwordChanged,
        //Added by Octopus DevTeam Feb 24 2022
        hasEnabledPassword: data.hasEnabledPassword,
        enablePassword: data.enablePassword,
        winrmUsername: data.winrmUsername,
        winrmPassword: data.winrmPassword,
        powerCliUsername: data.powerCliUsername,
        powerCliPassword: data.powerCliPassword,

        //DevTeam Sept 01, 2022
        healthMonitorInterval: data.healthMonitorInterval,

        sshAlgorithm: data.sshAlgorithm,
        enableRemediation: data.enableRemediation,
        
        winrmhttps: data.winrmhttps,
        httpsCertFilePath: data.httpsCertFilePath,

        msTenantId: data.msTenantId,
        msClientId: data.msClientId,
        msSubject: data.msSubject,

        //FIXME unclear
        clientIpAddress: '123.345.456.11',
        msbViolation: 1,
        pciCompliance: 0,
        cisCompliance: 0,
        configurationPath: "test",
    }
}

//Added by Octopus  DevTeam july 13-2022
export async function exportDevicesData(pageNumber, pageSize) {
    let filename = "Devices.xlsx";
    const queryString = getSortAndFilterQueryString(pageNumber, pageSize);
    const token = sessionStorage.getItem('access_token');

    await fetch(`${DEVICE_API}/export-to-excel?${queryString}`,{
 
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        
        body: JSON.stringify({
            filename: filename
        })

    }).then(async (res)=>{
        const responseJson = await res.blob();
        fileSaver.saveAs(responseJson, filename);
    });
}

export function applyBaseline(deviceDetails) {
    // alert ("deviceId: "+deviceDetails.deviceId+"  -deviceTypeId: "+deviceDetails.deviceTypeId+"  -msbId: "+deviceDetails.msbId);

    const token = sessionStorage.getItem('access_token');
    return fetch(`${DEVICE_BASELINE_API}/applydevicebaseline`,
        {
            method: 'POST',
            headers: {
                // 'Content-Type': 'text/plain',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify({ devicedetails: deviceDetails })
        })
        .then(response => response.json())
        .then(data => {
            return data;
        });

}


export function uploadWinrmHttpsCertificate(file) {
    const formData = new FormData();
    formData.append('certificate', file);
    
    return fetch(`${DEVICE_API}/upload-certificate`,
        {
            method: 'POST',
            headers: {
                ...getAuthHeader()
            },
            body: formData
        })
        .then(response => response.json())  // Parse JSON instead of returning raw response
        .then(data => data.filePath);       // Extract filePath
}

export async function generateMSCertificate(hostName, subject) {

    const response = await fetch(`${DEVICE_API}/generatemscertificate`, {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sessionStorage.getItem('access_token')}`, 
        },
        body: JSON.stringify({ 
            hostName: hostName,
            subject: subject?.trim() ? subject.trim() : 'VarApp/O=octopus/C=US',
        }),
    });
    
    // Read thumbprint from header
    // const thumbprint = response.headers.get('X-Thumbprint-SHA1');
    // console.log('Thumbprint:', thumbprint); // paste into Azure portal
    
    // Trigger file download
    const blob = await response.blob();
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement('a');
    a.href     = url;
    a.download = `${hostName}_certificate.cer`;
    a.click();
    URL.revokeObjectURL(url);
}
